import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import Order from "./SuggestOrder";
import { Button, Result } from "antd";

const List = ({ showModal, setShowModal, driver }) => {
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();

  const [orders, setOrders] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [sent, setSent] = useState(false);

  const onSelectOrder = (order) => {
    // Always use uuid for consistency - since we use uuid as key in the list
    const orderId = order.uuid;

    // Use functional state update to prevent stale state issues
    setSelectedOrders((prevSelected) => {
      if (prevSelected.includes(orderId)) {
        // Remove from selection
        return prevSelected.filter((id) => id !== orderId);
      } else {
        // Add to selection
        return [...prevSelected, orderId];
      }
    });
  };

  useEffect(() => {
    fetchInitial();
    return () => {
      setOrders(null);
      setSelectedOrders([]);
    };
  }, []);

  useEffect(() => {
    if (!showModal) {
      setSelectedOrders([]);
    }
  }, [showModal]);

  const fetchInitial = async () => {
    setLoading(true);
    try {
      const { data } = await axios({
        url: `${process.env.REACT_APP_API_URL}/order_search/`,
        method: "POST",
        data: {},
      });
      const filteredOrders = data.filter(
        (order) =>
          order.owner === user.id && order.status === 1 && !order.driver,
      );
      setOrders(filteredOrders);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const sendOrders = () => {
    if (selectedOrders.length === 0) return;

    if (!window.wsConnection) {
      return;
    }

    // Filter orders by UUID (not by ID) since we store UUIDs in selectedOrders
    const _orders = orders.filter((order) =>
      selectedOrders.includes(order.uuid),
    );
    console.log("Sending orders:", _orders, driver);

    _orders.forEach((order) => {
      window.wsConnection._ws.send(
        JSON.stringify({
          command: "suggest_order",
          data: {
            order,
            driver_id: driver.user.id,
          },
        }),
      );
    });

    setSent(true);

    // Orders sent successfully

    // alert(_orders.length > 1 ? 'Заказы успешно отправлены' : 'Заказ успешно отправлен');
    // window.location.href = '/my-orders?selected=suggestions';
  };

  const onClose = () => {
    window.location.href = "/notifications?selected=suggestions";
  };

  console.log(driver);

  return (
    <div className="order-list__wrapper">
      {sent && (
        <Result
          status="success"
          title={
            selectedOrders.length > 1
              ? "Заказы успешно отправлены"
              : "Заказ успешно отправлен"
          }
          extra={[
            <Button type="default" onClick={onClose}>
              Закрыть
            </Button>,
          ]}
        />
      )}
      {!sent && (
        <div className="order-list">
          {orders &&
            orders.map((order) => (
              <Order
                key={`${order.uuid}-${selectedOrders.includes(order.uuid) ? "selected" : "unselected"}`}
                order={order}
                onSelectOrder={onSelectOrder}
                selectedOrders={selectedOrders}
                onlineDrivers={[]}
                setShowOnMap={() => {}}
              />
            ))}
        </div>
      )}
      {!sent && (
        <div className="order-list__bottom">
          <Button
            type="primary"
            onClick={sendOrders}
            disabled={selectedOrders.length === 0}
          >
            Предложить
          </Button>
        </div>
      )}
    </div>
  );
};

export default List;
